<template>
  <div>
    <va-modal
      :value="showModal"
      id="createMediaModal"
      ref="createMediaModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="true"
      :okText="this.$t('iframe.media_library.create')"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      @ok="handleSubmit"
      :ok-disabled="!canSubmit"
      :noOutsideDismiss="true">

      <div slot="header" class="d-flex justify--space-between">
        <span :class="{'col-width': isMobile}">
            <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ this.$t('iframe.media_library.create')}}</b></span>
          </span>
      </div>

      <MediaDetail
        v-model="mediaForm"
        :formErrors="mediaErrors"
        :collapsable="true"
        :clientOptions="clientOptions"
      />

    </va-modal>
  </div>

</template>

<script>
import {IframeService} from "@/api/IframeService";
import MediaDetail from '@/components/iframe/media-library/MediaDetail.vue';
import Errors from "@/utils/StandardErrors";
import Multiselect from "vue-multiselect";
const errorsPrefix = 'iframe.media_library.errors.'
export default {
  components: {Multiselect, MediaDetail },
  data() {
    return {
      showModal: false,
      isLoading: true,
      mediaForm: {
        icon: null,
        lang: null,
        name: null,
        sound: null,
        client: null,
      },
      mediaErrors: new Errors(),
      media: null,
    }
  },
  mounted() {
    this.showModal = true
  },
  methods: {
    handleSubmit: function() {
      if (this.canSubmit) {
        this.isSubmiting = true
        const formDataToSubmit = {...this.mediaForm}
        if(this.mediaForm.lang) {
          formDataToSubmit.lang = this.mediaForm.lang.lang
        }
        const formData = new FormData()
        Object.entries(formDataToSubmit).forEach(([key, val]) => {
          if(key === "client") {
            formData.append("clientId", val.id.toString())
          } else {
            formData.append(key, val)
          }
        })

        IframeService.createMedia(formData,  (formData.icon !== null || formData.sound !== null))
          .then(res => {
            this.showToast(this.$t('iframe.media_library.created_success'), this.$store.state.successToastOptions)
            this.$emit('created')
            this.showModal = false
          })
          .catch(errors => {
            console.log(errors)
            if(errors.response.status === 422) {
              this.mediaErrors.record(errors.response.data.errors, errorsPrefix)
            }
            this.showToast(this.$t('iframe.media_library.created_error'), this.$store.state.errorToastOptions)
          })
          .finally(() => { this.isSubmiting = false } )
      }
    }
  },
  computed: {
    canSubmit() {
      return (this.mediaForm.name !== null && this.mediaForm.name !== '') && !this.isSubmiting && this.mediaForm.icon !== null && this.mediaForm.sound !== null && this.mediaForm.client !== null
    },
    isMobile: function () {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          if(this.iframeService.entities.length === 1) {
            this.mediaForm.client = this.iframeService.entities[0]
          }
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        const consideredEntities = this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
        if (consideredEntities.length === 1) {
          this.mediaForm.client = consideredEntities[0]
        }
        return consideredEntities
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>
